/**
 * ClientIdeasRoute Component
 *
 * Route wrapper for the client ideas approval view.
 */

import React from "react";
import { useOutletContext } from "react-router-dom";
import { ClientIdeasView } from "../components/ClientIdeasView";

interface ApprovalOutletContext {
  clientId: string;
  token?: string;
}

export const ClientIdeasRoute: React.FC = () => {
  const { clientId, token } = useOutletContext<ApprovalOutletContext>();

  if (!token) {
    return (
      <div className="p-6 text-center text-gray-500">
        Please log in to view pending ideas
      </div>
    );
  }

  return <ClientIdeasView clientId={clientId} token={token} />;
};
